export const CLIENT_SHOW_RESET = 'CLIENT_SHOW_RESET'
export const CLIENT_SHOW_SET_ERROR = 'CLIENT_SHOW_SET_ERROR'
export const CLIENT_SHOW_SET_RETRIEVED = 'CLIENT_SHOW_SET_RETRIEVED'
export const CLIENT_SHOW_SET_DOCUMENTS = 'CLIENT_SHOW_SET_DOCUMENTS'
export const CLIENT_SHOW_SET_PROJECTS = 'CLIENT_SHOW_SET_PROJECTS'
export const CLIENT_SHOW_SET_CONTACTS = 'CLIENT_SHOW_SET_CONTACTS'
export const CLIENT_SHOW_SET_ADDRESSES = 'CLIENT_SHOW_SET_ADDRESSES'
export const CLIENT_SHOW_TOGGLE_LOADING = 'CLIENT_SHOW_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/client/show/mutation_types.js